import { render } from "./SplitInfoBar.vue?vue&type=template&id=53be5126&scoped=true"
import script from "./SplitInfoBar.vue?vue&type=script&lang=js"
export * from "./SplitInfoBar.vue?vue&type=script&lang=js"

import "../../assets/scss/document_edit.scss?vue&type=style&index=0&id=53be5126&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53be5126"]])

export default __exports__